import config from '../data/config.json';

export const getAssetUrl = (path) => {
    if (!path) return '';
    // If the path is already a full external URL, return it directly
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Base URL resolution
    const baseUrl = config.assetBaseUrl || '/assets/images';
    
    // If it starts with http/https, use it directly
    if (baseUrl.startsWith('http://') || baseUrl.startsWith('https://')) {
        return `${baseUrl}/${cleanPath}`;
    }
    
    // Otherwise prepend process.env.PUBLIC_URL for local/relative deployment
    return `${process.env.PUBLIC_URL}${baseUrl}/${cleanPath}`;
};
